import React, {useEffect, useState} from "react";
import {defaultValues, updateHandleSubmit, createHandleSubmit} from "./index";
import validationSchema from "./validation-schema";
import ValidatedForm from "components/form";
import DataGrid, {DataGridItem} from "components/data-grid";
import FormTextField from "components/form/form-textfield";
import SelectMultipleChip from "components/select/select-multiple/select-multiple-chip";
import {useHistory} from "react-router-dom";
import {useSelector} from "react-redux";

const SubdeploymentForm = ({query, intl, onSuccess, id, handleClose, classes, edit, item}) => {
    const history = useHistory();
    const sourceList = useSelector(state => state.commonState.sourceList);

    const [formValues, setFormValues] = useState(defaultValues);

    const params = edit ? {
        updateSubdeployment: query,
        history,
        deploymentId: id,
        subdeploymentId: item.id,
        onSuccess
    } : {
        createSubdeployment: query,
        history,
        deploymentId: id,
        onSuccess
    }

    const formatValues = body => {
        const obj = {
            name: body.name,
            description: body.description,
            streamsourceIds: body.streamsourceIds
        };
        setFormValues(obj);
    };

    useEffect(() => {
        if (edit && item) {
            formatValues(item)
        }
    }, [edit, item]);

    return (
        <ValidatedForm
            initialValues={formValues}
            validationSchema={validationSchema(intl)}
            onSubmit={edit ? updateHandleSubmit(params) : createHandleSubmit(params)}
            onClose={handleClose}
            onCancel={handleClose}>
            {({values, handleChange}) => (
                <DataGrid>
                    <DataGridItem big>
                        <FormTextField
                            type="text"
                            id="name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "common.name"})}/>
                    </DataGridItem>
                    <DataGridItem big>
                        <FormTextField
                            type="text"
                            id="description"
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            label={intl.formatMessage({id: "common.description"})}
                        />
                    </DataGridItem>
                    <DataGridItem big>
                        <SelectMultipleChip
                            className={classes.sourceSelect}
                            id="streamsourceIds"
                            name="streamsourceIds"
                            elements={sourceList}
                            getValueFromElement={source => source.id}
                            getLabelFromElement={source => source.description}
                            value={values.streamsourceIds}
                            label={intl.formatMessage({id: "app.page.deployment.details.selectSource"})}
                            onChange={handleChange}
                        />
                    </DataGridItem>
                </DataGrid>)}
        </ValidatedForm>
    )
};

export default SubdeploymentForm;